"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function save(key, value, suffix) {
    try {
        var finalKey = suffix ? key + "." + suffix : key;
        if (value) {
            window.localStorage.setItem(finalKey, value);
        }
        else {
            window.localStorage.removeItem(finalKey);
        }
    }
    catch (e) {
    }
}
exports.save = save;
function remove(key, suffix) {
    try {
        window.localStorage.removeItem(suffix ? key + "." + suffix : key);
    }
    catch (_a) {
    }
}
exports.remove = remove;
function get(key, suffix) {
    try {
        return window.localStorage.getItem(suffix ? key + "." + suffix : key);
    }
    catch (_a) {
        return null;
    }
}
exports.get = get;
//# sourceMappingURL=storage.js.map